import React from 'react';
import styled from 'styled-components';
import { Icon } from 'antd';

const SuggestionContainer = styled.div`
    border: 1px solid #d9b18f;
    border-radius: 8px; 
    padding: 16px;
    margin-bottom: 16px;
`;

const SuggestionTitle = styled.div`
    font-size: 17px;
    font-weight: bold;
`;

const SuggestionContent = styled.div`
    padding-top: 8px;
    clear: both;
`;

export default function SuggestionBlock({ title, children, showIcon = true, }) {
    return <SuggestionContainer>
        {showIcon && <Icon type='info-circle' style={{ float: 'left', paddingRight: '8px', color: '#aa0000', fontSize: '28px' }}/>}
        {title && <SuggestionTitle>{title}</SuggestionTitle>}
        <SuggestionContent>{children}</SuggestionContent>
    </SuggestionContainer>
}
